import styled from 'styled-components';

export const ModalHeader = styled.div`
  border-bottom: 1px solid var(--text-20);
`;
